import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Btn, Input } from "@/components/erp/ui";
import { toast } from "sonner";
import { AlertTriangle, Trash2 } from "lucide-react";

export const DesignErrors = ({ wo }) => {
  const [d, setD] = useState(null);
  const [f, setF] = useState({ description: "", wasted_g: "" });
  const load = () => { api.get(`/workorders/${wo.id}/design-errors`).then(({ data }) => setD(data)).catch(() => {}); };
  useEffect(() => { load(); }, [wo.id]);
  if (!d) return null;
  const add = async () => {
    if (!f.description.trim()) { toast.error("Keterangan error wajib diisi"); return; }
    try { await api.post(`/workorders/${wo.id}/design-errors`, { ...f, wasted_g: +f.wasted_g || 0 }); setF({ description: "", wasted_g: "" }); toast.success("Error design dicatat"); load(); }
    catch (e) { toast.error(e.response?.data?.detail || "Gagal mencatat"); }
  };
  const del = async (id) => { try { await api.delete(`/design-errors/${id}`); toast.success("Dihapus"); load(); } catch (e) { toast.error(e.response?.data?.detail || "Gagal menghapus"); } };
  return (
    <div className="mb-5 p-3 rounded-lg border border-slate-200" data-testid="design-errors">
      <div className="flex items-center gap-2 mb-2 flex-wrap">
        <AlertTriangle className="w-4 h-4 text-amber-500" />
        <span className="text-xs font-mono text-slate-500">ERROR DESIGN & PRODUKSI</span>
        <span data-testid="wo-error-pct" className={`ml-auto text-xs rounded-full px-2 py-0.5 ${d.bonus_void ? "bg-rose-100 text-rose-700" : "bg-emerald-50 text-emerald-700"}`}>
          Error {d.error_pct}% / batas {d.limit_pct}%{d.bonus_void ? " · bonus tahap WO ini batal" : ""}
        </span>
      </div>
      {d.items.length === 0 && <div className="text-xs text-slate-400">Belum ada error design dicatat.</div>}
      {d.items.map((x) => (
        <div key={x.id} data-testid={`design-error-${x.id}`} className="flex items-start gap-2 text-sm py-1.5 border-t border-slate-100">
          <div className="flex-1"><div>{x.description}</div><div className="text-[11px] text-slate-400">{x.wasted_g} g terbuang · designer {x.designer || "-"} · dicatat {x.reported_by} · {new Date(x.created_at).toLocaleString("id-ID")}</div></div>
          {d.can_delete && <button data-testid={`design-error-del-${x.id}`} onClick={() => del(x.id)} className="text-slate-400 hover:text-rose-500"><Trash2 className="w-4 h-4" /></button>}
        </div>
      ))}
      {d.can_add && (
        <div className="flex gap-2 mt-2 flex-wrap">
          <Input data-testid="design-error-desc" className="flex-1 min-w-[180px]" placeholder="Mis. ukuran file salah, dinding terlalu tipis" value={f.description} onChange={(e) => setF({ ...f, description: e.target.value })} />
          <Input data-testid="design-error-gram" type="number" className="w-28" placeholder="Gram" value={f.wasted_g} onChange={(e) => setF({ ...f, wasted_g: e.target.value })} />
          <Btn data-testid="design-error-add" onClick={add}>Catat</Btn>
        </div>
      )}
      <p className="text-[11px] text-slate-400 mt-1">Isi gram material yang terbuang karena file design salah, di luar cacat yang sudah dicatat saat selesai cetak.</p>
    </div>
  );
};
